interface CallDirection {
  inbound?: boolean | null;
  incoming?: boolean | null;
}

export const isIncomingCall = (call: CallDirection): boolean =>
  call.inbound ?? call.incoming ?? false;

export const getCallDirectionLabel = (incoming: boolean): string =>
  incoming ? 'Inbound Call' : 'Outbound Call';
